import { getSession } from './auth';

/**
 * Chamadas às Edge Functions.
 *
 * Eram blocos de `fetch` cru copiados entre os chamadores, cada um remontando
 * URL, apikey e cabeçalho de autorização. Ficam aqui pelo mesmo motivo das
 * consultas: é acesso à rede, e a fila offline precisa enxergar isso num lugar
 * só.
 *
 * Aviso para a fase offline: isto NÃO é enfileirável como as gravações de
 * tabela. São funções que só existem online (criação de usuário, licença) —
 * sem conexão o certo é avisar, não guardar para depois.
 */

const url = () => process.env.REACT_APP_SUPABASE_URL;
const anonKey = () => process.env.REACT_APP_SUPABASE_ANON_KEY;

/** Cabeçalhos autenticados, com a chave anônima como reserva. */
export const edgeAuthHeaders = async () => {
  const session = await getSession();
  return {
    'Authorization': `Bearer ${session?.access_token || anonKey()}`,
    'apikey': anonKey(),
  };
};

/**
 * Invoca uma função e devolve o corpo já em JSON.
 *
 * Não estoura por status: alguns chamadores olham `success` no corpo e outros
 * olham `response.ok`, com mensagens de erro diferentes. Devolver os dois
 * preserva cada tratamento como estava.
 */
export const callEdgeFunction = async (name, body, { requireSession = false } = {}) => {
  const session = await getSession();
  const token = requireSession ? session?.access_token : (session?.access_token || anonKey());

  const response = await fetch(`${url()}/functions/v1/${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'apikey': anonKey(),
    },
    body: JSON.stringify(body),
  });

  return { ok: response.ok, status: response.status, data: await response.json() };
};
